import { render, staticRenderFns } from "./works_comic.vue?vue&type=template&id=2c4ddf91&scoped=true&"
import script from "./works_comic.vue?vue&type=script&lang=js&"
export * from "./works_comic.vue?vue&type=script&lang=js&"
import style0 from "./works_comic.vue?vue&type=style&index=0&id=2c4ddf91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ddf91",
  null
  
)

export default component.exports